import { Action } from 'redux';

import { IMetricInfo } from '../../../ts/models/IMetricInfo';
import { ResumeMetric, UpdateMetricsData, UpdateMetricsDataSucceeded } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface UpdateMetricsDataAction extends Action {
  metrics: IMetricInfo[];
}

export function updateMetricsData(metrics: IMetricInfo[]): UpdateMetricsDataAction {
  return {
    type: UpdateMetricsData,
    metrics
  };
}

export interface UpdateMetricsDataSucceededAction extends Action {
  readonly metrics: ReadonlyArray<IMetricInfo>;
}

export function updateMetricsDataSucceeded(metrics: ReadonlyArray<IMetricInfo>): UpdateMetricsDataSucceededAction {
  return {
    type: UpdateMetricsDataSucceeded,
    metrics
  };
}

export interface ResumeMetricAction extends Action {
  metric: IMetricInfo;
}

export function resumeMetric(metric: IMetricInfo): ResumeMetricAction {
  return {
    type: ResumeMetric,
    metric
  };
}

export const isUpdateMetricsDataSucceededAction = isActionFactory<UpdateMetricsDataSucceededAction>(UpdateMetricsDataSucceeded);
